import React from 'react';
import { BsArrowDown, BsArrowUp, BsArrowDownUp, BsThreeDotsVertical, BsList } from 'react-icons/bs';

const TableHeader = ({ 
  headers = [], 
  headerBgColor = 'bg-gray-50',
  sortConfig = { key: null, direction: null },
  onSort,
  actionsDisplayMode = 'inline',
  onToggleActionMode,
  fixedActionMode = false,
  grid = false,
  showActions = true,
  tooltipEnabled = false,
}) => {
  if (!headers || headers.length === 0) return null;

  const getSortIcon = (headerKey) => {
    if (sortConfig.key !== headerKey) {
      return <BsArrowDownUp className="w-4 h-4 ml-1 text-gray-400" />;
    }
    return sortConfig.direction === 'asc' 
      ? <BsArrowUp className="w-4 h-4 ml-1 text-gray-600" />
      : <BsArrowDown className="w-4 h-4 ml-1 text-gray-600" />;
  };

  const handleSort = (header) => {
    if (!header.sortable) return;
    
    let direction = 'asc';
    if (sortConfig.key === header.key) {
      direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
    }
    onSort(header.key, direction);
  };

  // Filter out the actions column if actionsDisplayMode is 'none'
  const visibleHeaders = actionsDisplayMode === 'none' 
    ? headers.filter(header => header.key !== 'actions')
    : headers;

  return (
    <thead className={headerBgColor}>
      <tr>
        {visibleHeaders.map((header, index) => (
          <th
            key={header.key}
            className={`px-4 py-2.5 text-left text-xs font-bold text-gray-500 tracking-wider 
            whitespace-nowrap min-w-[100px] border-b-2 border-gray-300 ${
              grid ? 'border-x border-gray-200' : ''
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                {header.sortable !== false && (
              <button
                onClick={() => handleSort(header)}
                    className="flex items-center focus:outline-none"
              >
                <span>{header.label}</span>
                {getSortIcon(header.key)}
              </button>
                )}
                {header.sortable === false && header.label}
              </div>
              {header.key === 'actions' && actionsDisplayMode !== 'none' && !fixedActionMode && (
              <button
                onClick={onToggleActionMode}
                  className="p-1 hover:bg-gray-100 rounded-full focus:outline-none"
                  title={actionsDisplayMode === 'inline' ? 'Switch to dropdown' : 'Switch to inline'}
              >
                  {actionsDisplayMode === 'inline' ? (
                    <BsThreeDotsVertical className="h-4 w-4" />
                  ) : (
                    <BsList className="h-4 w-4" />
                  )}
              </button>
            )}
          </div>
        </th>
        ))}
        {actionsDisplayMode !== 'none' && (
          <th className={`px-4 py-2.5 text-right text-xs font-bold text-gray-500 uppercase tracking-wider sticky right-0 ${headerBgColor} z-5 shadow-[-8px_0_12px_-6px_rgba(0,0,0,0.25)] whitespace-nowrap min-w-[100px] border-b-2 border-gray-300 ${grid ? 'border-x border-gray-200' : ''}`}>
            <div className="flex items-center justify-end">
              <span>Actions</span>
              {!fixedActionMode && (
                <button
                  onClick={onToggleActionMode}
                  className="ml-2 text-gray-400 hover:text-gray-600 focus:outline-none"
                  title={`Switch to ${actionsDisplayMode === 'inline' ? 'dropdown' : 'inline'} mode`}
                >
                  {actionsDisplayMode === 'inline' ? '⋮' : '≡'}
                </button>
              )}
            </div>
          </th>
        )}
      </tr>
    </thead>
  );
};

export default TableHeader;
